var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.iconComponent)?_c(_setup.iconComponent,{key:_vm.icon,tag:"component",class:{ 'h-full w-full': _vm.containerSize }}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }